import { render } from "./MiddleTitle.vue?vue&type=template&id=b71d47bc&scoped=true"
import script from "./MiddleTitle.vue?vue&type=script&lang=js"
export * from "./MiddleTitle.vue?vue&type=script&lang=js"

import "./MiddleTitle.vue?vue&type=style&index=0&id=b71d47bc&scoped=true&lang=scss"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71d47bc"]])

export default __exports__